import { render, staticRenderFns } from "./DeCanvas.vue?vue&type=template&id=15b926f0&"
import script from "./DeCanvas.vue?vue&type=script&lang=js&"
export * from "./DeCanvas.vue?vue&type=script&lang=js&"
import style0 from "./DeCanvas.vue?vue&type=style&index=0&id=15b926f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports